/**
 * @author: dwi.setiyadi@gmail.com
*/

import React from 'react';

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  // {
  //   path: '/',
  //   exact: true,
  //   name: 'Home',
  // },
  {
    path: '/users',
    exact: true,
    name: 'User Management',
    component: React.lazy(() => import('./views/UserManagement')),
  },
];

export default routes;
